import { Helmet } from "react-helmet-async";
import { MarketingIntakeWizardContainer } from "@platform/features/marketing";

/** The intake form the contact page is. */
const CONTACT_FORM_SLUG = "contact";

/**
 * Where somebody writes to us without being any particular audience.
 *
 * It is an intake form like the others, so it looks like them and what is
 * written here is recorded with every other inquiry. What it asks, and what
 * the panel beside it says, are configured on the form.
 */
export function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Pollinator | Contact</title>
      </Helmet>
      <MarketingIntakeWizardContainer formSlug={CONTACT_FORM_SLUG} />
    </>
  );
}

export default ContactPage;
